<template>
  <div class="page">
    <div
      class="container"
      :class="isSafari?['safari']:[]"
    >
      <menu-home></menu-home>
      <div class="slot"></div>

      <div
        class="info-part"
        v-if="walletAddress!=''"
      >
        <div class="short-cut">
          <img
            class="login btn"
            @click="connectFox"
            title="Login"
            v-if="!walletAddress"
            src="../assets/buy/metaloginicon.png"
          >
          <img
            class="login btn"
            @click="connectRabby"
            title="Login"
            v-if="!walletAddress"
            src="../assets/buy/rabbyloginicon.png"
          >
          <img
            class="login btn"
            @click="loginHandler"
            title="Login"
            v-if="!walletAddress"
            src="../assets/buy/loginicon.png"
          >

          <img
            class="login btn"
            @click="loginOutHandler"
            v-if="walletAddress"
            title="Logout"
            src="../assets/buy/loginouticon.png"
          >
          <img
            class="login btn"
            @click="chatHandler"
            title="Help Center"
            src="../assets/buy/chaticon.png"
          >
        </div>
      </div>
      <div class="content">
        <div
          class="top-login"
          v-if="walletAddress==''"
        >
          <div class="info-part">
            <div class="short-cut">
              <img
                class="login btn"
                @click="connectFox"
                title="Login"
                v-if="!walletAddress"
                src="../assets/buy/metaloginicon.png"
              >
              <img
                class="login btn"
                @click="connectRabby"
                title="Login"
                v-if="!walletAddress"
                src="../assets/buy/rabbyloginicon.png"
              >
              <img
                class="login btn"
                @click="loginHandler"
                title="Login"
                v-if="!walletAddress"
                src="../assets/buy/loginicon.png"
              >

              <img
                class="login btn"
                @click="loginOutHandler"
                v-if="walletAddress"
                title="Logout"
                src="../assets/buy/loginouticon.png"
              >
              <img
                class="login btn"
                @click="chatHandler"
                title="Help Center"
                src="../assets/buy/chaticon.png"
              >
            </div>
          </div>
          <div class="login-tip">Log in to your wallet and check your token balance</div>
        </div>
        <div
          class="top-address"
          v-else
        >
          <div class="top-item">{{!walletAddress?"Log in to your wallet and check your token balance":"Wallet Address:"}}<span>{{ formatWalletAddress(walletAddress) }}</span></div>
          <div>{{orderData.length >0?"Order Code:":""}}
            <div
              v-for="(item,index) in orderData"
              :key="index"
            >
              <div class="code-part">
                <div class="code-name">
                  <!-- USE THE NEW FORMATTING FUNCTION -->
                  {{ formatOrderCode(item.code) }}
                </div>
                <div class="buy-time">{{item.createAtDesc}}</div>
                <div
                  class="go-claim"
                  @click="goDetailHandler(item)"
                >Go</div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="toptitle"
          v-if="list.length > 0"
        ><img
            src="@/assets/token/6.png"
            alt=""
            srcset=""
          ></div>
        <div
          class="info"
          v-if="list.length > 0"
        ><span class="outline">{{zpTotal.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}} $ZP:</span> Vesting: {{ currentOrderItem.tge }}% unlock on TGE, {{ currentOrderItem.cliff }} cliff, {{ currentOrderItem.vesting }} months linear release.</div>
        <div
          class="item"
          :class="showIndex==index?['active']:[]"
          v-for="(item,index) in list"
          :key="index"
        >
          <div class="item-child">
            <div class="more-info">
              <div
                class="more-info-item flex space-between align-items"
                @click="showUpItem(index)"
              >
                <div class="title">ALLOCATION <span style="margin-left: 10px;">{{(index+1)}}</span></div>
                <div class="desc">

                  <div class="text-dark dark:text-white"> <svg
                      v-if="showIndex!=index"
                      stroke="currentColor"
                      fill="currentColor"
                      stroke-width="0"
                      viewBox="0 0 20 20"
                      aria-hidden="true"
                      height="30"
                      width="30"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                        clip-rule="evenodd"
                      ></path>
                    </svg><svg
                      v-if="showIndex==index"
                      stroke="currentColor"
                      fill="currentColor"
                      stroke-width="0"
                      viewBox="0 0 20 20"
                      aria-hidden="true"
                      height="30"
                      width="30"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                        clip-rule="evenodd"
                      ></path>
                    </svg></div>
                </div>
              </div>
              <div class="contract"><a
                  href="https://www.kaiascan.io/token/0x6009950e4b05fba0f95fe799ce47b56e2de4a34f?tabId=overview&page=1"
                  target="_blank"
                  rel="noreferrer"
                  class="flex items-center gap-3 text-darkOrange font-semibold hover:underline"
                >Contract<svg
                    stroke="currentColor"
                    fill="currentColor"
                    stroke-width="0"
                    viewBox="0 0 24 24"
                    height="20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M8.465 11.293c1.133-1.133 3.109-1.133 4.242 0l.707.707 1.414-1.414-.707-.707c-.943-.944-2.199-1.465-3.535-1.465s-2.592.521-3.535 1.465L4.929 12a5.008 5.008 0 0 0 0 7.071 4.983 4.983 0 0 0 3.535 1.462A4.982 4.982 0 0 0 12 19.071l.707-.707-1.414-1.414-.707.707a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243l2.122-2.121z"></path>
                    <path d="m12 4.929-.707.707 1.414 1.414.707-.707a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.243l-2.122 2.121c-1.133 1.133-3.109 1.133-4.242 0L10.586 12l-1.414 1.414.707.707c.943.944 2.199 1.465 3.535 1.465s2.592-.521 3.535-1.465L19.071 12a5.008 5.008 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0z"></path>
                  </svg></a></div>
              <div class="more-info-item flex space-between align-items">
                <div class="sub-title">ALLOCATED:</div>
                <div class="sub-desc">{{item.allocated.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}} $ZP</div>
              </div>
              <div class="more-info-item flex space-between align-items">
                <div class="sub-title">CLAIM TIME:</div>
                <div class="sub-desc">{{item.claimAtDesc}} UTC</div>
              </div>
              <div class="more-info-item flex space-between align-items">
                <div class="sub-title">STATUS:</div>
                <!-- 0:lock 1.可以领取 2.转账中.3.已领取 -->
                <div
                  class="sub-desc"
                  :title="countStatus(item)"
                >{{countStatus(item)}}</div>
              </div>
            </div>
            <div class="bottom-part">
              <img
                src="@/assets/locked.png"
                class="locked-img"
                alt=""
                v-if="item.status==0"
              >
              <div
                class="claim-btn"
                :class="item.status==2 || item.status==3?['claim-disable-btn']:[]"
                @click="claimHandler(item)"
                v-else
              >CLAIM</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <QRCodeView
      v-if="showQrcodeTag"
      @hideQrCode="hideQrCode"
      :url="qrcodeUrl"
    ></QRCodeView>
  </div>
</template>
<script>
import { pvzwebLoginByWallet, pvzwebUserClaim, pvzwebUserClaimList, pvzwebUserOrderList } from '@/common/method';
import MenuHome from './MenuHome.vue';
import QRCodeView from './QRCodeView.vue';
import { OKXUniversalProvider } from '@okxconnect/universal-provider';
import QRCode from 'qrcode';
import { emitter, Events } from '@/common/mitt';
import lib from '@/common/rabby';

export default {
  components: { MenuHome, QRCodeView },
  name: 'ClaimToken',
  data () {
    return {
      // data
      showIndex: 0,
      zpTotal: 0,
      orderData: [],
      isKyc: false,//是否认证过
      okxUniversalProvider: null,
      walletAddress: "",
      list: [],
      showQrcodeTag: false,
      qrcodeUrl: '', // Added for QR code data URL
      currentOrderItem: null, // Added to store the currently selected order item details
    }
  },
  methods: {
    updateAccountHandler (accounts) {
      this.loginByWallet(accounts[0]) // Assuming the first account is the primary one
    },
    formatWalletAddress (address) {
      if (!address) return '';
      return `${address.slice(0, 2)}...${address.slice(-4)}`;
    },
    // ADDED: Function to format order codes
    formatOrderCode (code) {
      if (!code) return '';
      const prefixLength = 4; // Show first 4 chars
      const suffixLength = 4; // Show last 4 chars
      if (code.length <= prefixLength + suffixLength + 3) { // 3 for "..."
        return code; // Don't shorten if it's already short
      }
      return `${code.slice(0, prefixLength)}...${code.slice(-suffixLength)}`;
    },
    async connectRabby () {
      if (window.ethereum && window.ethereum.isRabby == true) {
        lib.connectWithEIP6963()
      } else {
        emitter.emit(
          Events.EventMin,
          `Please install ${'Rabby Wallet'} to log in or select an alternative wallet.`
        );
      }
    },
    async connectFox () {
      if (window.ethereum && window.ethereum.isMetaMask == true) {
        lib.connectWithEIP6963("MetaMask")
      } else {
        emitter.emit(
          Events.EventMin,
          `Please install ${'MetaMask'} to log in or select an alternative wallet.`
        );
      }
    },
    goDetailHandler (item) {
      this.showIndex = -1; // Reset expanded item view
      this.currentOrderItem = item; // Store the selected order details
      pvzwebUserClaimList({ token: localStorage.getItem("token"), code: item.code, orderObjId: item.id }).then(res => {
        let detail_result = res.data;
        if (detail_result.errCode == 0) {
          let result = detail_result.data;
          this.list = result || []; // Ensure list is an array
          this.zpTotal = 0;
          this.list.forEach(claimItem => { // Use forEach for clarity
            this.zpTotal += claimItem.allocated;
          });
        } else {
          emitter.emit(Events.EventMin, detail_result.errMsg);
          this.list = []; // Clear list on error
          this.zpTotal = 0;
        }
      }).catch(error => {
        console.error("Error fetching claim list:", error);
        emitter.emit(Events.EventMin, "Failed to fetch claim details.");
        this.list = [];
        this.zpTotal = 0;
      });
    },
    chatHandler () {
      window.open("https://t.me/Telgatherminigames", "_blank"); // Open in new tab
    },
    async hideQrCode () {
      this.showQrcodeTag = false;
      if (this.okxUniversalProvider) {
        // Attempt disconnect if needed, handle potential errors
        try {
          // await this.okxUniversalProvider.disconnect(); // Check OKX provider docs for correct disconnect method if needed
        } catch (e) { console.error("Error during OKX QR disconnect attempt:", e); }
      }
      this.okxUniversalProvider = null;
    },
    loginByWallet (address) {
      if (!address) {
        console.warn("Login attempt with no address.");
        return;
      }
      this.walletAddress = address;
      pvzwebLoginByWallet({ walletType: 'multi', walletAddress: this.walletAddress }).then(res => { // Use generic type or detect
        let ax_result = res.data;
        if (ax_result.errCode != 0) {
          emitter.emit(Events.EventMin, ax_result.errMsg);
          this.clearData(); // Clear data on login failure
          return;
        }
        let result = ax_result.data;
        this.token = result.token;
        this.isKyc = result.isKyc;
        localStorage.setItem("token", this.token);
        this.showQrcodeTag = false; // Hide QR if it was open
        this.init(); // Fetch user data after successful login
      }).catch(error => {
        console.error("Error during wallet login API call:", error);
        emitter.emit(Events.EventMin, "Login failed. Please try again.");
        this.clearData();
      });
    },
    async loginHandler () { // OKX Web Wallet specific logic
      if (typeof window.okxwallet !== 'undefined') {
        console.log('OKX Wallet is installed!');
        try {
          const accounts = await window.okxwallet.request({ method: 'eth_requestAccounts' });
          if (accounts && accounts.length > 0) {
            this.loginByWallet(accounts[0]);
          } else {
            console.warn("OKX Wallet returned no accounts.");
            emitter.emit(Events.EventMin, "Could not get account from OKX Wallet.");
          }
        } catch (error) {
          console.error('Error requesting accounts from OKX Wallet:', error);
          if (error.code === 4001) { // User rejected request
            emitter.emit(Events.EventMin, "Login request rejected.");
          } else {
            emitter.emit(Events.EventMin, "Failed to connect with OKX Wallet.");
          }
        }
      }
      else {
        // Fallback to QR code method if OKX Wallet extension is not found
        this.loginInitQRCODE();
      }
    },
    async loginOutHandler () {
      console.log('logout!');
      localStorage.removeItem("token"); // Use removeItem

      try {
        lib.disconnect(); // Disconnect Rabby/MetaMask via EIP6963
        if (window.okxwallet && typeof window.okxwallet.disconnect === 'function') { // Check if disconnect exists
          await window.okxwallet.disconnect();
        }
        if (this.okxUniversalProvider && typeof this.okxUniversalProvider.disconnect === 'function') { // Check if disconnect exists
          await this.okxUniversalProvider.disconnect();
        }
      } catch (e) {
        console.error("Error during wallet disconnection:", e);
      }

      this.clearData();
    },
    clearData () {
      this.orderData = [];
      this.okxUniversalProvider = null; // Ensure provider is cleared
      this.walletAddress = "";
      this.list = [];
      this.zpTotal = 0;
      this.showQrcodeTag = false;
      this.currentOrderItem = null;
      this.token = null; // Clear token
      this.isKyc = false; // Reset KYC status
    },
    async loginInitQRCODE () { // OKX QR Code Logic
      if (this.okxUniversalProvider) {
        console.log("OKX Universal Provider already initialized or connection attempt in progress.");
        return; // Prevent multiple initializations
      }
      try {
        this.okxUniversalProvider = await OKXUniversalProvider.init({
          dappMetaData: {
            name: "Web3.0 Plants vs Zombies",
            icon: "https://res.telgather.com/mini/ton/Telgather/Telgather.jpg",
            // url: window.location.origin // Good practice to add dApp URL
          },
        });

        this.okxUniversalProvider.on("display_uri", (uri) => {
          console.log("display_uri:", uri);
          this.showQRCode(uri);
        });

        this.okxUniversalProvider.on("session_update", (session) => {
          console.log("OKX session_update:", JSON.stringify(session));
          if (session && session.namespaces && session.namespaces.eip155 && session.namespaces.eip155.accounts && session.namespaces.eip155.accounts.length > 0) {
            let wallet = session.namespaces.eip155.accounts[0]; // e.g., "eip155:1:0x..."
            let addressParts = wallet.split(':');
            let address = addressParts[addressParts.length - 1];
            this.loginByWallet(address);
            this.hideQrCode(); // Hide QR code after successful connection
          } else {
            console.warn("Session update did not contain expected account info.");
          }
        });

        this.okxUniversalProvider.on("session_delete", ({ topic }) => {
          console.log("OKX session_delete, topic:", topic);
          // Optionally handle session deletion, e.g., by logging out the user if the session matches the current one
          this.loginOutHandler(); // Consider logging out if the session is deleted
        });

        // Define required and optional chains/methods
        const namespaces = {
          eip155: {
            methods: ["eth_sendTransaction", "eth_signTransaction", "personal_sign"],
            chains: ["eip155:1"], // Example: Ethereum Mainnet
            events: ["accountsChanged", "chainChanged"],
            rpcMap: { // Provide RPC URLs for the chains you need
              // 1: `https://mainnet.infura.io/v3/${YOUR_INFURA_PROJECT_ID}` // Replace with your RPC
            }
          },
        };
        // Example using optionalNamespaces if needed:
        // const optionalNamespaces = { eip155: { chains: ["eip155:137"] } }; // Polygon

        console.log("Attempting to connect via OKX Universal Provider...");
        const session = await this.okxUniversalProvider.connect({ namespaces }); // Pass namespaces here
        console.log("OKX Universal Provider connect successful, session:", session);
        // Session update event usually handles login, but can double-check here
        if (session && session.namespaces && session.namespaces.eip155 && session.namespaces.eip155.accounts && session.namespaces.eip155.accounts.length > 0) {
          let wallet = session.namespaces.eip155.accounts[0];
          let addressParts = wallet.split(':');
          let address = addressParts[addressParts.length - 1];
          if (!this.walletAddress) { // Login only if not already logged in via session_update
            this.loginByWallet(address);
          }
          this.hideQrCode();
        } else {
          console.warn("Connection successful but no account info found in initial session.");
        }

      } catch (error) {
        console.error("Error initializing or connecting OKX Universal Provider:", error);
        emitter.emit(Events.EventMin, "Failed to initiate QR code login.");
        this.okxUniversalProvider = null; // Reset provider on error
        this.hideQrCode();
      }
    },
    showQRCode (link) {
      this.showQrcodeTag = true;
      QRCode.toDataURL(link, { errorCorrectionLevel: 'L' }, (error, url) => { // Added error correction level option
        if (error) {
          console.error("QR Code generation failed:", error);
          emitter.emit(Events.EventMin, "Could not generate QR code.");
          this.showQrcodeTag = false; // Hide if generation fails
        } else {
          this.qrcodeUrl = url;
          console.log("QR Code image successfully generated!");
        }
      });
    },
    countStatus (item) {
      switch (item.status) {
        case 0: return "LOCKED";
        case 1: return "READY TO CLAIM";
        case 2: return "PENDING";
        case 3: return item.successTransHash ? `LANDED: ${this.formatTxHash(item.successTransHash)}` : "LANDED IN WALLET"; // Show shortened hash if available
        default: return "UNKNOWN";
      }
    },
    // Helper function to format transaction hashes (optional)
    formatTxHash (hash) {
      if (!hash) return '';
      return `${hash.slice(0, 6)}...${hash.slice(-4)}`;
    },
    showUpItem (index) {
      this.showIndex = this.showIndex === index ? -1 : index; // Toggle logic
    },
    claimHandler (item) {
      if (item.status !== 1) { // Check if status allows claiming
        console.log("Claim attempt on item with status:", item.status);
        return; // Do nothing if not ready to claim
      }
      if (!this.currentOrderItem) {
        emitter.emit(Events.EventMin, "Please select an order first.");
        return;
      }

      // Optionally add a confirmation dialog here

      pvzwebUserClaim({ token: localStorage.getItem("token"), claimObjId: item.id }).then(res => {
        let result = res.data;
        if (result.errCode == 0) {
          emitter.emit(Events.EventMin, "Claim request submitted successfully. Status will update shortly.");
          // Refresh the details for the current order after a short delay to allow backend processing
          setTimeout(() => {
            if (this.currentOrderItem) { // Check if still selected
              this.goDetailHandler(this.currentOrderItem);
            }
          }, 3000); // Refresh after 3 seconds (adjust as needed)
        } else {
          emitter.emit(Events.EventMin, `Claim failed: ${result.errMsg}`);
        }
      }).catch(error => {
        console.error("Error during claim API call:", error);
        emitter.emit(Events.EventMin, "Claim request failed. Please try again.");
      });
    },
    refreshAccountHandler (res) {
      // This handler seems unused based on provided code, but keep if needed elsewhere
      console.log("Refresh Account Info Triggered:", res);
      // Potentially re-fetch data if needed: this.init();
    },
    isSafari () {
      // More robust Safari detection (handles Chrome on iOS which includes 'Safari')
      const ua = navigator.userAgent.toLowerCase();
      return ua.includes('safari') && !ua.includes('chrome') && !ua.includes('crios') && !ua.includes('fxios');
    },
    init () {
      const token = localStorage.getItem("token");
      if (!token) {
        console.log("No token found, clearing data.");
        this.clearData(); // Ensure clean state if no token
        return;
      }

      this.showIndex = -1; // Reset expansion
      this.list = [];      // Clear previous claim list
      this.zpTotal = 0;    // Reset total

      pvzwebUserOrderList({ token }).then(res => {
        let result = res.data;
        if (result.errCode == 0) {
          let data = result.data || []; // Ensure data is an array
          this.orderData = data.filter(item => item.orderStatus == 1); // Filter for active orders
          // Optionally auto-select the first order if available
          // if (this.orderData.length > 0) {
          //   this.goDetailHandler(this.orderData[0]);
          // }
        } else {
          emitter.emit(Events.EventMin, `Failed to load orders: ${result.errMsg}`);
          this.orderData = []; // Clear orders on error
        }
      }).catch(error => {
        console.error("Error fetching user orders:", error);
        emitter.emit(Events.EventMin, "Failed to load your orders.");
        this.orderData = [];
      });
    },
    // Function to handle EIP-6963 wallet selection and connection
    async handleWalletSelection (providerDetail) {
      console.log("Selected provider:", providerDetail.info.name);
      try {
        // Assuming 'lib' handles the connection based on the provider
        await lib.connectProvider(providerDetail.provider);
        // Account update should be triggered by the 'Update_Account' event listener
      } catch (error) {
        console.error(`Failed to connect with ${providerDetail.info.name}:`, error);
        emitter.emit(Events.EventMin, `Connection failed with ${providerDetail.info.name}.`);
      }
    },
  },
  mounted () {
    emitter.on(Events.Update_Account, this.updateAccountHandler);
    emitter.on(Events.Refresh_Account_Info, this.refreshAccountHandler);
    // Listen for wallet selection if using a wallet selector component that emits this
    // emitter.on('select-wallet', this.handleWalletSelection);

    // Check for existing token on mount
    if (localStorage.getItem("token")) {
      this.init(); // Load data if already logged in
    } else {
      // Attempt to reconnect automatically or check URL params?
      // The URL param check might be redundant if EIP-6963 handles persistence well
      let url = window.location.search;
      if (url.includes("address=")) {
        const params = new URLSearchParams(url);
        const address = params.get("address");
        if (address) {
          // Potentially risky to auto-login from URL param without verification
          // Consider removing this or adding a confirmation step
          console.log("Address found in URL, attempting login (use with caution):", address);
          this.loginByWallet(address); // Decide if this auto-login is desired/secure
        }
      } else {
        // Try to announce providers for EIP-6963 compatible wallets immediately
        lib.announceProviders();
      }
    }

  },
  unmounted () {
    emitter.off(Events.Update_Account, this.updateAccountHandler);
    emitter.off(Events.Refresh_Account_Info, this.refreshAccountHandler);
    // emitter.off('select-wallet', this.handleWalletSelection);
    lib.reset(); // Clean up listeners from rabby/EIP-6963 library
    // Clean up OKX provider listeners
    if (this.okxUniversalProvider) {
      this.okxUniversalProvider.off("display_uri");
      this.okxUniversalProvider.off("session_update");
      this.okxUniversalProvider.off("session_delete");
      // Attempt disconnect if provider exists
      // this.okxUniversalProvider.disconnect().catch(e => console.error("Error disconnecting OKX provider on unmount:", e));
    }
  },
}
</script>
<style scoped lang="scss">
// --- Keep existing styles ---
.page {
  width: 100%;
  overflow-x: hidden;
  position: relative;
  height: auto;
  margin: 0 auto;
  background-color: #1a1a1a; /* Added a fallback background */
}

.container {
  background: url('../assets/claimbg.jpg') no-repeat center center / cover;
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;

  // Safari specific blur fix (if needed, test thoroughly)
  &.safari {
    /* backdrop-filter might need vendor prefix or specific handling */
    /* -webkit-backdrop-filter: blur(0); */ /* Example, might not be needed */
  }

  .content {
    width: 90%;
    max-width: 1170px;
    margin: 0 auto;
    padding-bottom: 50px; // Ensure space at the bottom
  }

  .login {
    cursor: pointer;
    margin: 10px;
    width: 50px; // Slightly smaller for better fit
    height: 50px;
    object-fit: contain;
    // max-width: 10%; // Max-width might not be ideal here
    transition: transform 0.2s ease-in-out;
    &:hover {
      transform: scale(1.1);
    }
  }

  // Positioned on top right when logged in
  .info-part {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 10; // Ensure it's above other content if needed

    .short-cut {
      display: flex;
      gap: 10px; // Spacing between icons
      background-color: rgba(0, 0, 0, 0.5); // Slight background for visibility
      padding: 5px 10px;
      border-radius: 30px;
    }
  }

  // Centered login section when logged out
  .top-login {
    text-align: center;
    background-color: rgba(0, 0, 0, 0.7); // Darker background
    border-radius: 20px;
    padding: 30px 20px;
    line-height: 1.5;
    font-size: clamp(16px, 2vw, 22px); // Adjusted size
    color: #e0e0e0; // Lighter gray
    margin: 120px auto 30px auto; // Add top margin to avoid menu overlap
    max-width: 600px; // Limit width

    .info-part {
      position: static; // Override absolute positioning from the other .info-part
      margin: 0 auto;
      width: auto;
      padding-bottom: 20px; // Space before tip

      .short-cut {
        justify-content: center; // Center icons
        flex-wrap: wrap;
        background-color: transparent; // No extra background needed here
        padding: 0;
      }
    }

    .login-tip {
      width: 90%;
      max-width: 450px;
      text-align: center;
      margin: 20px auto 0;
      padding-top: 20px;
      font-weight: bold;
      font-size: clamp(18px, 2.2vw, 24px);
      border-top: 1px solid #555; // Slightly lighter border
      color: #f0f0f0;
    }
  }

  // Address and Order section when logged in
  .top-address {
    text-align: left;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 20px;
    padding: 20px 30px;
    margin: 120px auto 30px auto; // Match top margin
    line-height: 1.6;
    font-size: clamp(16px, 1.8vw, 20px);
    color: #dcdcdc;
    max-width: 1170px; // Match content max-width

    .top-item {
      padding-bottom: 10px;
      margin-bottom: 15px;
      border-bottom: 1px solid #555;
      font-weight: bold;
      span {
        // Style for the address itself
        color: #f39700; // Orange color for address
        margin-left: 8px;
        word-break: break-all; // Prevent overflow
      }
    }

    // Styling for the order codes section
    div:nth-of-type(2) {
      // Target the div containing orders
      font-weight: bold;
      margin-top: 10px;
    }

    .code-part {
      display: flex; // Arrange horizontally
      justify-content: space-between; // Space out elements
      align-items: center;
      color: white;
      font-weight: normal; // Normal weight for details
      padding: 8px 5px; // Reduced padding
      margin-top: 8px;
      border-bottom: 1px dashed #444; // Dashed separator

      &:last-child {
        border-bottom: none;
      }

      .code-name {
        flex-basis: 40%; // Allocate space
        font-weight: bold; // Make code bold
        color: #f0f0f0;
      }
      .buy-time {
        flex-basis: 40%; // Allocate space
        color: #aaa; // Lighter gray for time
        font-size: clamp(12px, 1.5vw, 16px); // Smaller font size
        text-align: right; // Align time right
      }
      .go-claim {
        flex-basis: 15%; // Allocate space
        text-decoration: underline;
        color: #f39700;
        cursor: pointer;
        font-size: clamp(14px, 1.6vw, 18px);
        text-align: right;
        font-weight: bold;
        transition: color 0.2s;
        &:hover {
          color: #ffbf57; // Lighter orange on hover
        }
      }
    }
  }

  .outline {
    font-weight: bold;
    font-size: clamp(20px, 2.8vw, 26px); // Adjusted size
    color: #f39700;
  }

  .claim-btn,
  .claim-disable-btn {
    background-color: #f39700;
    padding: 10px 15px; // Adjusted padding
    width: 70%; // Relative width
    max-width: 250px; // Max width
    margin: 20px auto;
    border-radius: 50px;
    color: white;
    font-weight: bold;
    font-size: clamp(16px, 2.5vw, 22px); // Adjusted font size
    cursor: pointer;
    border: none;
    text-align: center;
    transition: background-color 0.2s, transform 0.1s;
    &:hover {
      background-color: #d98700; // Darker orange on hover
      transform: translateY(-1px);
    }
    &:active {
      transform: translateY(1px);
    }
  }

  .claim-disable-btn {
    background-color: #484848;
    color: #888; // Darker gray text
    cursor: not-allowed;
    &:hover {
      background-color: #484848; // No hover effect
      transform: none;
    }
  }

  .text-dark svg {
    // Target SVG within .text-dark
    font-size: clamp(18px, 2vw, 25px);
    width: 30px;
    height: 30px;
    cursor: pointer;
    color: #e0e0e0; // Icon color
    transition: color 0.2s;
    &:hover {
      color: #f39700;
    }
  }

  .slot {
    height: 100px; // Space below the fixed menu
    width: 100%;
    flex-shrink: 0; // Prevent shrinking
  }

  .toptitle {
    margin: 30px 0 15px 0; // Adjusted margin
    text-align: center;

    img {
      max-width: 80%; // Limit image width
      height: auto;
      max-height: 80px; // Limit height
      object-fit: contain;
    }
  }

  .info {
    margin-top: 15px;
    background-color: rgba(0, 0, 0, 0.6); // Slightly more transparent
    padding: 15px 20px;
    font-size: clamp(14px, 2vw, 18px); // Adjusted size
    line-height: 1.6;
    color: #e0e0e0;
    text-align: center;
    border-radius: 10px; // Rounded corners
  }

  // Moved short-cut styling primarily to .info-part and .top-login
  // .short-cut { ... }

  .item {
    transition: max-height 0.3s ease-out, background-color 0.2s; // Smooth height transition
    margin: 15px 0;
    overflow: hidden;
    background-color: rgba(30, 30, 30, 0.7); // Darker item background
    border-radius: 10px;
    max-height: 100px; // Collapsed height (adjust based on header size) - includes padding
    border: 1px solid #444;

    &.active {
      max-height: 700px; // Expanded height (ensure it's large enough)
      background-color: rgba(
        40,
        40,
        40,
        0.85
      ); // Slightly different expanded background
    }

    .item-child {
      // Container for content inside item
    }

    .more-info-item {
      display: flex; // Use flexbox for layout
      justify-content: space-between;
      align-items: center;
      padding: 15px 20px; // Consistent padding
      border-bottom: 1px solid #555;
      cursor: default; // Default cursor for info rows

      &:first-child {
        // The clickable header row
        cursor: pointer; // Pointer only for the header
      }

      &:last-child {
        border-bottom: none;
      }
    }

    .contract {
      font-size: clamp(13px, 1.8vw, 16px);
      display: flex;
      align-items: center; // Vertically align icon and text
      // justify-content: flex-end; // Moved to parent container layout if needed
      // margin-right: 10px; // Removed, spacing handled by parent padding
      padding: 10px 20px; // Add specific padding if needed outside item rows
      border-bottom: 1px solid #555; // Separator line

      a {
        // Style the link within .contract
        color: #f39700;
        text-decoration: none;
        display: flex;
        align-items: center;
        gap: 5px; // Space between text and icon
        &:hover {
          text-decoration: underline;
          color: #ffbf57;
        }
        svg {
          color: #f39700; // Match link color
        }
      }
    }

    .title {
      font-size: clamp(16px, 2.2vw, 20px);
      color: white;
      font-weight: bold;
      line-height: 1.5;
    }

    .desc {
      // font-size: clamp(16px, 2.5vw, 24px); // Defined by svg container now
      color: white;
      font-weight: bold;
      display: flex; // To align the icon
      align-items: center;
    }

    .sub-title {
      font-size: clamp(14px, 1.8vw, 18px);
      color: #b0b0b0; // Slightly lighter gray
      font-weight: 500; // Medium weight
      flex-basis: 40%; // Give title fixed space
    }
    .sub-desc {
      font-size: clamp(14px, 1.8vw, 18px);
      color: #e0e0e0; // Lighter text for values
      font-weight: 500;
      text-align: right; // Align value to the right
      flex-basis: 60%; // Give value more space
      word-break: break-word; // Break long hashes or statuses
    }
  }

  .bottom-part {
    padding: 20px 0 30px 0; // Adjusted padding
    text-align: center;
    border-top: 1px solid #555; // Separator before button/image
    margin-top: 10px; // Space above separator

    .locked-img {
      max-width: 80%; // Limit size
      height: auto;
      max-height: 60px; // Max height for the lock image
      object-fit: contain;
      margin-top: 10px; // Space above lock image
    }
  }

  // Ensure flex utilities work if not globally defined
  .flex {
    display: flex;
  }
  .space-between {
    justify-content: space-between;
  }
  .align-items {
    align-items: center;
  }
  .gap-3 {
    gap: 0.75rem;
  } // Adjust gap value as needed
  .font-semibold {
    font-weight: 600;
  }
  .hover\:underline:hover {
    text-decoration: underline;
  }
  .text-darkOrange {
    color: #f39700;
  } // Use variable or direct color
}

// Responsive adjustments if needed
@media (max-width: 768px) {
  .container {
    .info-part {
      // Adjust login/logout icon position on smaller screens
      top: 15px;
      right: 15px;
      .short-cut {
        padding: 3px 8px;
      }
      .login {
        width: 40px;
        height: 40px;
        margin: 5px;
      }
    }
    .top-login,
    .top-address {
      margin-top: 80px; // Less top margin
      padding: 20px 15px;
    }
    .top-address .code-part {
      flex-direction: column; // Stack order details vertically
      align-items: flex-start; // Align left
      gap: 5px;
      .code-name,
      .buy-time,
      .go-claim {
        flex-basis: auto; // Reset basis
        text-align: left; // Align all left
        width: 100%; // Take full width
      }
      .buy-time {
        font-size: clamp(11px, 1.4vw, 14px);
      }
      .go-claim {
        text-align: left;
        margin-top: 5px;
      }
    }
    .item {
      max-height: 85px;
    } // Adjust collapsed height for smaller titles
    .item .more-info-item {
      padding: 10px 15px;
    }
    .item .title {
      font-size: clamp(15px, 2.5vw, 18px);
    }
    .item .sub-title,
    .item .sub-desc {
      font-size: clamp(13px, 2vw, 16px);
    }
    .claim-btn,
    .claim-disable-btn {
      font-size: clamp(15px, 3vw, 20px);
      max-width: 200px;
      padding: 8px 12px;
    }
  }
}
</style>